/* unplugin-vue-components disabled */import { render } from "./IntroVoice.vue?vue&type=template&id=6b88711e&scoped=true"
import script from "./IntroVoice.vue?vue&type=script&lang=js"
export * from "./IntroVoice.vue?vue&type=script&lang=js"

import "./IntroVoice.vue?vue&type=style&index=0&id=6b88711e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b88711e"]])

export default __exports__